import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import VerticalFlex from "layouts/flex/VerticalFlex";
import P from "components/P";
import Dummy from "components/Dummy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";

function Shopping() {
    const { id } = useParams();
    const [shoppingMalls] = useState([
        {
            id: 1,
            name: "K-PUFFU",
            url: "https://puffuandroid.com",
            icon: fas.faStore,
            color: "#FF6B6B"
        },
        {
            id: 2,
            name: "PUFFUTOY",
            url: "https://puffuandroid.com",
            icon: fas.faShoppingBasket,
            color: "#4ECDC4"
        },
        {
            id: 3,
            name: "PUFFU보따리",
            url: "https://puffuandroid.com",
            icon: fas.faShoppingBag,
            color: "#45B7D1"
        },
        {
            id: 4,
            name: "PUFFU BUILD",
            url: "https://puffuandroid.com",
            icon: fas.faStoreAlt,
            color: "#96CEB4"
        }
    ]);

    const handleOpenExternalLink = (url) => {
        const encoded = encodeURIComponent(url);
        const redirectUrl = `https://puffu.kr/open-external?target=${encoded}`;
      
        // WebView 내에서는 location.href 로 이동해서 네이티브 감지 유도
        window.location.href = redirectUrl;
      };

    return (
        <div style={{ height: "100%", backgroundColor: "#fff" }}>
            <Dummy height={"56px"} />
            <div style={{
                padding: "20px",
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "16px"
            }}>
                {shoppingMalls.map((mall) => (
                    <div
                        key={mall.id}
                        // onClick={() => handleOpenExternalLink(mall.url)}
                        style={{
                            backgroundColor: "#FFFFFF",
                            borderRadius: "16px",
                            padding: "24px 16px",
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            border: "1px solid #f5f5f5"
                        }}
                    >
                        <div style={{
                            width: "56px",
                            height: "56px",
                            borderRadius: "16px",
                            backgroundColor: mall.color,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <FontAwesomeIcon 
                                icon={mall.icon} 
                                style={{ 
                                    fontSize: "24px",
                                    color: "#FFFFFF"
                                }} 
                            />
                        </div>
                        <P color={"#333"} size={15} weight={600} style={{ textAlign: "center" }}>
                            {mall.name}
                        </P>
                        <P color={"#999"} size={13}>(준비중)</P>
                    </div>
                ))}
            </div>
            <div style={{
                position: "fixed",
                bottom: "80px",
                left: 0,
                right: 0,
                padding: "16px",
                textAlign: "center",
                backgroundColor: "rgba(255, 255, 255, 0.9)"
            }}>
                <P color={"#666"} size={13}>
                    클릭 시 외부 링크로 연결됩니다
                </P>
            </div>
            <Dummy height={"80px"} />
        </div>
    );
}

export default Shopping; 